module.exports = __webpack_public_path__ + "img/lva.8b293d98.svg";